// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__368Cz","additionalInfo":"AgreementModal_additionalInfo__2Xmnh"};